<template>
  <div :class="className">
    <b-row class="cookie-container">
      <b-col sm="12" class="cookie-description">
        <p class="mt-2">
          By browsing this site, you acknowledge that you have read our
          <a href="https://www.notion.so/wearecoal/Terms-Privacy-Policy-f965a13c53164cd4888555f048da9f87">privacy policy</a><br/>
          and agree to our use of cookies.
        </p>
      </b-col>
      <b-col sm="12" class="cookie-button">
        <b-button @click="acceptCookies" variant="coal-yellow">Accept</b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: 'Cookies',
  data() {
    return {
      accepted: false,
    };
  },
  computed: {
    className() {
      return `accept-cookies ${this.accepted ? 'hide' : ''}`;
    },
  },
  methods: {
    acceptCookies() {
      this.$store.commit('useCookies');
      this.accepted = true;
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../assets/css/variables';

  .accept-cookies {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    background-color: $yellow;
    padding: 20px 40px 25px;
    color: #141414;
    font-size: 14.4px;
    font-family: $font-sans-serif-reg;
    z-index:9999999;

    p {
      margin: 0;
    }

    a, a:visited, a:active, a:focus {
      color: inherit;
    }

    button {
      border: 1px solid $white;
      width: 100%;
      padding: 20px;
      margin-top: 20px;
      font-size: 16px;
      font-family: $font-sans-serif-med;
    }

    &.hide {
      display: none;
    }
  }

  .desktop {
    .cookie-container {
      max-width: 988px;
      margin: 0 auto;

      .cookie-description {
        max-width: 750px;
        padding: 0;
        margin: 0;
      }

      .cookie-button {
        max-width: 168px;
        padding: 0;
        margin: 0;

        button {
          margin: 0;
        }
      }
    }
  }
</style>
